import React from 'react';
import { formatTimezones } from '@/lib/helpers/multi-livestream/formatTimezones';
import TimezoneToggle from '@/components/TimezoneToggle/TimezoneToggle';
import ExternalLinkIcon from '/public/svg/external-link.svg';
import styles from '@/components/MultiLivestream/StationInfo.module.scss';
interface MultiLivestreamStationInfoProps {
  primaryTimezone: string;
  secondaryTimezone?: string | null;
  scheduleUrl: string;
  stationName: string;
}
const MultiLivestreamStationInfo = (props: MultiLivestreamStationInfoProps) => {
  const {
    primaryTimezone,
    secondaryTimezone,
    scheduleUrl,
    stationName
  } = props;
  return <div className={styles.multi_livestream__station_info} data-sentry-component="MultiLivestreamStationInfo" data-sentry-source-file="MultiLivestreamStationInfo.tsx">
      {/* Timezone, for stations with only one timezone  */}
      {primaryTimezone && !secondaryTimezone && <span className={styles.timezone}>
          Timezone: {formatTimezones(primaryTimezone)}
        </span>}
      {/* Timezone Toggle, for stations with two timezones  */}
      {secondaryTimezone && <div className={styles.timezone}>
          <TimezoneToggle secondaryTimezone={secondaryTimezone} displayPrimaryTimezone={formatTimezones(primaryTimezone)} displaySecondaryTimezone={formatTimezones(secondaryTimezone)} />
        </div>}
      <div className={styles.multi_livestream__station_info__name_link}>
        <h2 className={styles.multi_livestream__station_name}>
          {stationName} Live TV Schedule
        </h2>
        {/* Link to full On Air Schedule */}
        {scheduleUrl && <a className={styles.multi_livestream__schedule_link} href={scheduleUrl}>
            <span className={styles.multi_livestream__schedule_link__text}>
              On Air Schedule
            </span>
            <ExternalLinkIcon className={styles.multi_livestream__schedule_link__icon} />
          </a>}
      </div>
    </div>;
};
export default MultiLivestreamStationInfo;